let API_URL;

// Même machine en dev : accepter localhost ET 127.0.0.1 (sinon API_URL pointe vers la prod)
const isLocalDev =
  window.location.hostname === "localhost" ||
  window.location.hostname === "127.0.0.1" ||
  window.location.hostname === "[::1]";

if (isLocalDev) {
  API_URL = "http://localhost:5000";
} else {
  API_URL = "https://my-portfolio-0g0m.onrender.com";
}

export { API_URL };